module.exports = __webpack_public_path__ + "img/onjn-romania.0d0ee8c6.png";